import { Card, Container, Grid, Stack } from "@mui/material";
import React from "react";
import classes from "./Maintenance.module.css";
import { motion as m } from "framer-motion";
import EngineeringIcon from "@mui/icons-material/Engineering";
import MovingParticles from "../../components/Animation/MovingParticles";

const Maintenance = () => {
  return (
    <>
      <m.div
        initial={{ y: "100%" }}
        animate={{ y: "0%" }}
        transition={{
          duration: 0.75,
          type: "spring",
          stiffness: 500,
          damping: 60,
        }}
        exit={{ opacity: 1 }}
        className={classes.page}
      >
        <Container maxWidth="xl">
          <Grid
            container
            direction="row"
            alignItems="stretch"
            justifyContent="center"
            sx={{ pb: { xs: 3 } }}
          >
            <Grid item xs={12}>
              <Card
                sx={{
                  bgcolor: "#1C1C1C",
                  color: "white",
                  borderRadius: 8,
                  height: "80vh",
                }}
              >
                <MovingParticles />

                <Grid
                  container
                  justifyContent={"center"}
                  alignContent={"center"}
                  height={"90%"}
                >
                  <Grid item>
                    <Stack alignItems={"center"}>
                      <EngineeringIcon fontSize="large" />

                      <h3>Working on Updates</h3>
                    </Stack>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </m.div>
    </>
  );
};

export default Maintenance;
